import PageBaseButton from './PageBaseButton';

interface CsvExportButtonProps {
  onClick: () => void;
  buttonLabel?: string;
}

const CsvExportButton = ({
  onClick,
  buttonLabel = 'CSV出力',
}: CsvExportButtonProps) => {
  return (
    <PageBaseButton
      variant="csv-custom"
      buttonText={buttonLabel}
      onClick={onClick}
    />
  );
};

export default CsvExportButton;
